import API from "@/constant/API";
import RouteConstant from "@/constant/RouteConstant";
import useSettings from "@/hook/useSettings";
import { getUserInfo } from "@/redux/slices/user";
import { dispatch } from "@/redux/store";
import axiosInstance from "@/utils/axios";
import SumsubWebSdk from "@sumsub/websdk-react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {Box} from '@mui/material';

export const KYC_LEVEL_STANDARD = 1;
export const KYC_LEVEL_EN_DOC = 3;
export const KYC_LEVEL_EXPIRED = 4;

function SumsubKyc({onComplete}) {
  const levelRef = useRef(KYC_LEVEL_STANDARD);
  const {settings} = useSettings();
  const navigate = useNavigate();
  const {state} = useLocation()

  const {user} = useSelector((state) => state.user);

  const { t } = useTranslation();

  useEffect(() => {
    // state 如果定义有sumsub kyc level，使用level请求sumsub accessToken
    if (state?.level) {
      levelRef.current = state.level;
    }
  }, []);

  useEffect(() => {
    if (user) {
      _refreshAccessToken();

      // _updateByKycStatus(user.kycStatus);
    }
  }, [user]);

  const _getSumsubConfig = () => {
    return {
      // String	No	Language of WebSDK texts and comments in ISO 639-1 format.	'en'
      lang: settings?.lang || 'en',
      // String	No	Alpha-3 country code (Wikipedia) to prefill it on document upload screen.
      // country,
      // String	No	User's email to propagate it to the applicant.
      // email,
      // String	No	User's phone number to propagate it to the applicant.
      // phone,
      // 'dark' or 'light'	No	Set either a light or dark theme. By default, the theme is selected automatically.
      theme: settings?.theme,
    };
  }

  const [accessToken, setAccessToken] = useState(null);
  const [config, setConfig] = useState(_getSumsubConfig());

  useEffect(() => {
    if (settings?.lang && config?.lang !== settings?.lang) {
      // set config 并不能使sumsub sdk重新加载 需要刷新页面
      // setConfig(_getSumsubConfig());
      window.location.reload();
    }
  }, [settings?.lang]);

  const _accessTokenExpirationHandler = () => {
    _refreshAccessToken();
  };

  const _refreshAccessToken = async () => {
    try {
      const res = await axiosInstance.post(API.KYC_TOKEN, {
        level: levelRef.current,
      });
      setAccessToken(res.token);
    } catch(err) {
      // 出错后返回上一页
      navigate(-1);
    }
  };

  // const _updateByKycStatus = async (kycStatus) => {
  //   // kyc被拒绝但可重新发起请求
  //   setReject(kycStatus === KYC_STATUS.KYC_STATUS_REJECT);

  //   // kyc被拒绝 终态 无法重新请求
  //   setRejectFinal(kycStatus === KYC_STATUS.KYC_STATUS_REJECT_FINAL);
  // };

  const _messageHandler = (action, response) => {
    // console.log("人脸核验结果",response)
    if (response?.reviewStatus === "completed") {
      // TODO: 可能需要延时刷新用户userInfo 检查是否sumsub front sdk回调是否比服务回调处理更快
      // 或新增轮询接口检查系统同步的kyc状态
      dispatch(getUserInfo());

      // response?.reviewResult?.reviewRejectType === "FINAL" 拒绝终态
      if (response?.reviewResult?.reviewAnswer === 'RED') {
        // 被打回
      } else {
        // 通过
        if (onComplete) {
          onComplete();
        } else {
          // 检查用户是否还在向导步骤(未买卡)，返回home
          if (user.isBuyCard != true) {
            navigate(RouteConstant.HOME, { 
              replace: true,
            });
          }else{
            navigate(RouteConstant.MAIN, { 
              replace: true,
            });
          }
        }
      }
    }
  };
  const _errorHandler = () => {
  };
  // const handleContinue = () => {
  //   navigate(RouteConstant.GUIDE_KYC_PRE);
  // };

  if (!accessToken) return null;

  //审核中， 拒绝， final reject
  // if([KYC_STATUS.KYC_STATUS_SUBMITTED,KYC_STATUS.KYC_STATUS_RESUBMITTED,KYC_STATUS.KYC_STATUS_REJECT,KYC_STATUS.KYC_STATUS_REJECT_FINAL].includes(user?.kycStatus)  ){

  //只显示被拒绝重试状态
  // if (user?.kycStatus === KYC_STATUS.KYC_STATUS_REJECT) {
  //   const isReject = user?.kycStatus === KYC_STATUS.KYC_STATUS_REJECT;

  //   return (
  //     <div className="w-full h-full">
  //       <div className="relative mt-[100px] flex justify-center mb-[56px]">
  //         <img src="/images/others/kyc-auth.png" className="w-[192px]"/>
  //         <div className="absolute top-[81px] text-primary-main">
  //           <RpIcon icon="error-fill" size={28}/>
  //         </div>
  //       </div>
  //       <div className="mb-4 text-black dark:text-white text-center text-3xl">
  //         {user?.kycStatus === KYC_STATUS.KYC_STATUS_SUBMITTED ||
  //         user?.kycStatus === KYC_STATUS.KYC_STATUS_RESUBMITTED
  //           ? t("authenticating")
  //           : t("authentication_failed")}
  //       </div>
  //       <div className="mb-12 text-text-secondary dark:text-text-dark-secondary text-center text-lg">
  //         {user?.kycStatus === KYC_STATUS.KYC_STATUS_SUBMITTED ||
  //         user?.kycStatus === KYC_STATUS.KYC_STATUS_RESUBMITTED
  //           ? t("authenticating_tip")
  //           : t("authentication_failed_tip")}
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <Box
    sx={{
      width: '100%',
      height: '100%',
      '& > div': {
        height: '100% !important',
      },
      '& iframe': {
        height: '100% !important',
      }
    }}
  >
    <SumsubWebSdk
      style={{ width: '100%' }}
      accessToken={accessToken}
      expirationHandler={_accessTokenExpirationHandler}
      config={config}
      options={{ addViewportTag: false, adaptIframeHeight: false}}
      onMessage={_messageHandler}
      onError={_errorHandler}
    />
  </Box>

  );
}

export default SumsubKyc;
